var _circle, _path, _line, _line2, _mask, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 64,
    viewBox: "0 0 77 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 32,
    r: 30.5,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 32C51.5 40.6542 49.7429 48.4149 46.9721 53.9566C44.1564 59.588 40.544 62.5 37 62.5C33.456 62.5 29.8436 59.588 27.0279 53.9566C24.2571 48.4149 22.5 40.6542 22.5 32C22.5 23.3458 24.2571 15.5851 27.0279 10.0434C29.8436 4.412 33.456 1.5 37 1.5C40.544 1.5 44.1564 4.412 46.9721 10.0434C49.7429 15.5851 51.5 23.3458 51.5 32Z",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20.5,
    x2: 66,
    y2: 20.5,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 43.5,
    x2: 66,
    y2: 43.5,
    stroke: "black",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_2789_33061",
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 30,
    width: 24,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 53,
    y: 30,
    width: 24,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 40H68.5V39C68.5 37.067 66.933 35.5 65 35.5C63.067 35.5 61.5 37.067 61.5 39V40ZM71 40C72.6569 40 74 41.3431 74 43V53C74 54.6569 72.6569 56 71 56H59C57.3431 56 56 54.6569 56 53V43C56 41.3431 57.3431 40 59 40V39C59 35.6863 61.6863 33 65 33C68.3137 33 71 35.6863 71 39V40Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 40H68.5V39C68.5 37.067 66.933 35.5 65 35.5C63.067 35.5 61.5 37.067 61.5 39V40ZM71 40C72.6569 40 74 41.3431 74 43V53C74 54.6569 72.6569 56 71 56H59C57.3431 56 56 54.6569 56 53V43C56 41.3431 57.3431 40 59 40V39C59 35.6863 61.6863 33 65 33C68.3137 33 71 35.6863 71 39V40Z",
    fill: "#FF2E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 40H59.2V42.3H61.5V40ZM68.5 40V42.3H70.8V40H68.5ZM71 40H68.7V42.3H71V40ZM59 40V42.3H61.3V40H59ZM61.5 42.3H68.5V37.7H61.5V42.3ZM70.8 40V39H66.2V40H70.8ZM70.8 39C70.8 35.7967 68.2033 33.2 65 33.2V37.8C65.6627 37.8 66.2 38.3373 66.2 39H70.8ZM65 33.2C61.7967 33.2 59.2 35.7967 59.2 39H63.8C63.8 38.3373 64.3373 37.8 65 37.8V33.2ZM59.2 39V40H63.8V39H59.2ZM71 42.3C71.3866 42.3 71.7 42.6134 71.7 43H76.3C76.3 40.0729 73.9271 37.7 71 37.7V42.3ZM71.7 43V53H76.3V43H71.7ZM71.7 53C71.7 53.3866 71.3866 53.7 71 53.7V58.3C73.9271 58.3 76.3 55.9271 76.3 53H71.7ZM71 53.7H59V58.3H71V53.7ZM59 53.7C58.6134 53.7 58.3 53.3866 58.3 53H53.7C53.7 55.9271 56.0729 58.3 59 58.3V53.7ZM58.3 53V43H53.7V53H58.3ZM58.3 43C58.3 42.6134 58.6134 42.3 59 42.3V37.7C56.0729 37.7 53.7 40.0729 53.7 43H58.3ZM56.7 39V40H61.3V39H56.7ZM65 30.7C60.416 30.7 56.7 34.416 56.7 39H61.3C61.3 36.9565 62.9565 35.3 65 35.3V30.7ZM73.3 39C73.3 34.416 69.584 30.7 65 30.7V35.3C67.0435 35.3 68.7 36.9565 68.7 39H73.3ZM73.3 40V39H68.7V40H73.3Z",
    fill: "white",
    mask: "url(#path-5-outside-1_2789_33061)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 48,
    r: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.1382f18dba9fb95e310d41aa5afcd074.svg";
export { ForwardRef as ReactComponent };